import { getResponseData, requestFetch, resolveRequestUrl } from './request';

export type OpenApiRequestOptions = RequestInit & {
  skipErrorHandler?: boolean;
  timeout?: number;
};

export async function openApiRequest<T>(
  url: string,
  options: OpenApiRequestOptions = {},
) {
  const { skipErrorHandler, timeout, ...requestOptions } = options;
  const response = await requestFetch(resolveRequestUrl(url), requestOptions, {
    skipErrorHandler,
    timeout,
  });
  if (response.status === 204) {
    return undefined as T;
  }

  return getResponseData<T>(response);
}

export type ErrorType<Error> = Error;
export type BodyType<BodyData> = BodyData;
